import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IMigration } from '@shared';

@Component({
  selector: 'migrations-detail-modal',
  templateUrl: './migration-detail-modal.component.html',
  styleUrls: ['./migration-detail-modal.component.scss'],
})
export class MigrationDetailModalComponent {
  @Input() migration: IMigration;
  @Input() accountId: string;
  @Output() closeModal = new EventEmitter();
  error: Error;

  constructor(public activeModal: NgbActiveModal) {}
}
